module.exports = __webpack_public_path__ + "img/default_avatar_bg.379b3687.jpg";